import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PageHeaderComponent } from '../core/components/page-header/page-header.component';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { InputComponent } from '../core/components/input/input.component';
import { FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ContactUsService, Message } from './contact-us.service';
import { PublicService } from '../core/services/public.service';
import { CountryISO, NgxIntlTelInputModule, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../users/user.service';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [PageHeaderComponent, CommonModule, TranslateModule, InputComponent, FormsModule, NgxIntlTelInputModule, ReactiveFormsModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnDestroy, OnInit {

  contactUsLinks = [
    { name: 'footer.address', descriptionAr: 'أولا : 10 شارع إيران الدقي - الجيزة <br> ثانيا: 8 شارع قصر النيل – القاهرة', descriptionEn: 'H.Q.: 10 Iran St - Dokki Giza <br> Giza Branch: 8 Kasr El Nil St Cairo A.R.E', },
    { name: 'footer.phone', descriptionAr: '+202 37495371 / +202 37495370 <br> +202 25743177 / +202 25753188', descriptionEn: '+202 37495371 / +202 37495370 <br> +202 25743177 / +202 25753188' },
    { name: 'footer.poBox', descriptionAr: "ص.ب./611 الرمز البريدي 11511", descriptionEn: '611 Cairo PC 11511' },
    { name: 'footer.email', descriptionAr: "gaif@gaif.org", descriptionEn: "gaif@gaif.org" },
    { name: 'footer.fax', descriptionAr: "+202 25762310 / +202 33380209", descriptionEn: "+202 25762310 / +202 33380209" }
  ];
  isArabic: boolean = true;
  translateService = inject(TranslateService);
  toastrService = inject(ToastrService);
  contactUsService = inject(ContactUsService);
  userService = inject(UserService);
  publicService = inject(PublicService);
  subscriptions = new Subscription();
  message: Message = new Message()
  currentLanguage: any;
  countryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.Egypt
  ];
  searchCountryField = SearchCountryField;
  mobileForm!: FormGroup;
  mobile: Phone = new Phone();

  @ViewChild('messageForm') messageForm!: NgForm;

  constructor(
    private formBuilder: FormBuilder,

  ) {
    this.isArabic = this.userService.getCulture() === 'en' ? false : true;
    this.subscriptions.add(this.translateService.onDefaultLangChange.subscribe((res) => {
      if (res) {
        this.isArabic = (res.lang === 'ar' ? true : false);
      }
    }))
  }
  ngOnInit(): void {

    this.mobileForm = this.formBuilder.group({
      mobileFormControl: [''],
    });

  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  sendMessage() {
    this.message.dialCode = this.mobile.dialCode
    this.message.phone = this.mobile.e164Number;
    this.subscriptions.add(this.contactUsService.sendMessage(this.message).subscribe((res) => {
      if (res && res.success) {
        this.toastrService.success(this.translateService.instant('contactUs.thankYouForContacting'));
        this.mobileForm = this.formBuilder.group({
          mobileFormControl: [''],
        });
        this.message = new Message();
        this.messageForm.resetForm();

      }
    }))
  }

  get phoneFormGroupControl() {
    return this.mobileForm.controls;
  }
}
export class Phone {
  number: string = '';
  internationalNumber: string = '';
  nationalNumber: string = '';
  e164Number: string = '';
  countryCode: string = '';
  dialCode: string = CountryISO.Egypt;
}
